import { render, staticRenderFns } from "./SelectImage.vue?vue&type=template&id=5f54ada5&scoped=true"
import script from "./SelectImage.vue?vue&type=script&lang=js"
export * from "./SelectImage.vue?vue&type=script&lang=js"
import style0 from "./SelectImage.vue?vue&type=style&index=0&id=5f54ada5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f54ada5",
  null
  
)

export default component.exports